import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField
} from '@mui/material';

const AddCategoryDialog = ({ open, onClose, onSubmit, initialData }) => {
  const [typeName, setTypeName] = useState('');

  useEffect(() => {
    if (initialData) {
      setTypeName(initialData.type_name);
    } else {
      setTypeName('');
    }
  }, [initialData]);

  const handleSubmit = () => {
    if (typeName.trim()) {
      onSubmit(typeName);
      setTypeName('');
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{initialData ? 'Edit Category Type' : 'Add New Category Type'}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Type Name"
          fullWidth
          variant="outlined"
          value={typeName}
          onChange={(e) => setTypeName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained">
          {initialData ? 'Update' : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddCategoryDialog;
